/* eslint-disable */
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date and time, represented as an ISO-8601 string */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  URI: any;
};



export type Actor = Actor__Human | Actor__System | Actor__Unknown;

export type Actor__CreateInput = {
  actorType: Actor__Type;
  actorName?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['ID']>;
};

export type Actor__HasOne = {
  actor: Actor;
};

export type Actor__Human = Human__HasOne & {
  __typename?: 'Actor__Human';
  name: Scalars['String'];
  human: Human;
  userID?: Maybe<Scalars['ID']>;
};

export type Actor__System = {
  __typename?: 'Actor__System';
  name: Scalars['String'];
};

export enum Actor__Type {
  Driver = 'DRIVER',
  Human = 'HUMAN',
  System = 'SYSTEM',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type Actor__Unknown = {
  __typename?: 'Actor__Unknown';
  name: Scalars['String'];
};

export type Asset = Node & Driver__VehicleInspectionReport__HasMany & {
  __typename?: 'Asset';
  id: Scalars['ID'];
  customName?: Maybe<Scalars['String']>;
  defects?: Maybe<Asset__Defect_Queries>;
  vehicleInspectionReports?: Maybe<Array<Maybe<Driver__VehicleInspectionReport>>>;
};

export type Asset__Comments__And__Media = Node & Lifecycle__HasOne & Comment__HasMany & Media__HasMany & Asset__HasOne & {
  __typename?: 'Asset__Comments__And__Media';
  id: Scalars['ID'];
  asset: Asset__Result;
  comments?: Maybe<Array<Maybe<Comment>>>;
  media?: Maybe<Array<Media>>;
  lifecycle: Lifecycle;
};

export type Asset__Comments__And__Media__CreateInput = {
  assetID: Scalars['ID'];
  lifecycle: Lifecycle__CreateInput;
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Asset__Comments__And__Media__HasMany = {
  assetCommentsAndMedia?: Maybe<Array<Maybe<Asset__Comments__And__Media__Result>>>;
};

export type Asset__Comments__And__Media__Result = Asset__Comments__And__Media | Error__EntityNotFound | Error__DataIntegrity | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__UnclassifiedError;

export type Asset__Comments__And__Media__UpdateInput = {
  assetID: Scalars['ID'];
  dvirID: Scalars['ID'];
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Asset__Defect = Node & Lifecycle__HasOne & Comment__HasMany & Media__HasMany & WorkOrder__HasMany & Asset__HasOne & {
  __typename?: 'Asset__Defect';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  comments?: Maybe<Array<Maybe<Comment>>>;
  media?: Maybe<Array<Media__Read__Result>>;
  workOrders?: Maybe<Array<Maybe<WorkOrder__Result>>>;
  asset: Asset__Result;
  type: Asset__Defect__Type;
  severity: Asset__Defect__Severity;
  resolution?: Maybe<Asset__Defect__Resolution>;
};

export type Asset__Defect_Queries = {
  __typename?: 'Asset__Defect_Queries';
  all?: Maybe<Asset__Defect__Connection>;
};


export type Asset__Defect_QueriesAllArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  unresolvedOnly?: Maybe<Scalars['Boolean']>;
};

export type Asset__Defect__Connection = Pagination__Connection & {
  __typename?: 'Asset__Defect__Connection';
  edges: Array<Asset__Defect__Edge>;
  pageInfo: Pagination__PageInfo;
  totalCount: Scalars['Int'];
};

export type Asset__Defect__CreateInput = {
  assetID: Scalars['ID'];
  assetDefectTypeID: Scalars['ID'];
  driverVehicleInspectionReportID: Scalars['ID'];
  severity: Asset__Defect__Severity;
  lifecycle: Lifecycle__CreateInput;
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Asset__Defect__Edge = Pagination__Edge & {
  __typename?: 'Asset__Defect__Edge';
  cursor: Scalars['String'];
  node?: Maybe<Asset__Defect__Result>;
};

export type Asset__Defect__HasMany = {
  defects?: Maybe<Array<Maybe<Asset__Defect>>>;
};

export type Asset__Defect__Mutations = {
  __typename?: 'Asset__Defect__Mutations';
  create?: Maybe<Array<Maybe<Asset__Defect__Result>>>;
  delete?: Maybe<Array<Maybe<Asset__Defect__Result>>>;
  resolve?: Maybe<Array<Maybe<Asset__Defect__Resolution__Result>>>;
  update?: Maybe<Array<Maybe<Asset__Defect__Result>>>;
};


export type Asset__Defect__MutationsCreateArgs = {
  input: Array<Asset__Defect__CreateInput>;
};


export type Asset__Defect__MutationsDeleteArgs = {
  ids: Array<Scalars['ID']>;
};


export type Asset__Defect__MutationsResolveArgs = {
  input: Array<Asset__Defect__Resolution__ResolveInput>;
};


export type Asset__Defect__MutationsUpdateArgs = {
  input: Array<Asset__Defect__UpdateInput>;
};

export type Asset__Defect__Resolution = Node & Lifecycle__HasOne & Signature__HasOne & Comment__HasMany & {
  __typename?: 'Asset__Defect__Resolution';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  signature: Signature;
  comments?: Maybe<Array<Maybe<Comment>>>;
  type: Asset__Defect__Resolution__Type;
};

export type Asset__Defect__Resolution__ResolveInput = {
  assetDefectID: Scalars['ID'];
  assetDefectResolutionType: Asset__Defect__Resolution__Type;
  signatureID: Scalars['ID'];
  comments?: Maybe<Array<Comment__CreateInput>>;
  lifecycle: Lifecycle__CreateInput;
};

export type Asset__Defect__Resolution__Result = Asset__Defect__Resolution | Error__EntityNotFound | Error__DuplicateEntity | Error__InputValidation | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export enum Asset__Defect__Resolution__Type {
  Closed = 'CLOSED',
  Resolved = 'RESOLVED'
}

export type Asset__Defect__Result = Asset__Defect | Error__AccessForbidden | Error__DataIntegrity | Error__EntityNotFound | Error__InputValidation | Error__TimeoutError | Error__UnclassifiedError;

export enum Asset__Defect__Severity {
  Operational = 'OPERATIONAL',
  SoftDown = 'SOFT_DOWN',
  HardDown = 'HARD_DOWN'
}

export type Asset__Defect__Type = Node & Lifecycle__HasOne & {
  __typename?: 'Asset__Defect__Type';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  name: Scalars['String'];
  company?: Maybe<Company>;
  assetType: Asset__Type;
};

export type Asset__Defect__Type__ByNameInput = {
  assetTypeID: Scalars['Int'];
  name: Scalars['String'];
  companyID?: Maybe<Scalars['Int']>;
};

export type Asset__Defect__Type__CreateInput = {
  name: Scalars['String'];
  company: Company__Input;
  assetTypeID: Scalars['Int'];
  lifecycle: Lifecycle__CreateInput;
};

export type Asset__Defect__Type__CreateManyInput = {
  names: Array<Scalars['String']>;
  company: Company__Input;
  assetTypeID: Scalars['Int'];
  lifecycle: Lifecycle__CreateInput;
};

export type Asset__Defect__Type__Errors = Error__EntityNotFound | Error__InputValidation | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__AccessForbidden | Error__UnexpectedRestResponse;

export type Asset__Defect__Type__Mutations = {
  __typename?: 'Asset__Defect__Type__Mutations';
  /** Create one or more Asset Defect Type for a given company and Asset type. */
  create: Array<Maybe<Asset__Defect__Type__Result>>;
  /** Soft delete one or more Asset Defect Types for a given company. */
  delete?: Maybe<Array<Maybe<Asset__Defect__Type__Result>>>;
  /** Restore one or more previously deleted Asset Defect Type. */
  restore?: Maybe<Array<Maybe<Asset__Defect__Type__Result>>>;
};


export type Asset__Defect__Type__MutationsCreateArgs = {
  input: Asset__Defect__Type__CreateManyInput;
};


export type Asset__Defect__Type__MutationsDeleteArgs = {
  ids: Array<Scalars['ID']>;
};


export type Asset__Defect__Type__MutationsRestoreArgs = {
  ids: Array<Scalars['ID']>;
};

export type Asset__Defect__Type__Queries = {
  __typename?: 'Asset__Defect__Type__Queries';
  /** Query all default or default and Company specific Asset Defect Types. */
  all?: Maybe<Array<Maybe<Asset__Defect__Type__Result>>>;
  /** Query an Asset Defect Type by its unique ID. */
  byID?: Maybe<Array<Maybe<Asset__Defect__Type__Result>>>;
  /** Query all Company specific Asset Defect Types. */
  byCompanyID?: Maybe<Array<Maybe<Asset__Defect__Type__Result>>>;
  /** Query all Asset Defect Types by name and company. */
  byName?: Maybe<Asset__Defect__Type__Result>;
};


export type Asset__Defect__Type__QueriesAllArgs = {
  input: Asset__Defect__Type__QueryInput;
};


export type Asset__Defect__Type__QueriesByIdArgs = {
  id: Scalars['ID'];
};


export type Asset__Defect__Type__QueriesByCompanyIdArgs = {
  id: Scalars['ID'];
};


export type Asset__Defect__Type__QueriesByNameArgs = {
  input: Asset__Defect__Type__ByNameInput;
};

export type Asset__Defect__Type__QueryInput = {
  companyID: Scalars['Int'];
};

export type Asset__Defect__Type__Result = Asset__Defect__Type | Error__EntityNotFound | Error__InputValidation | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__AccessForbidden | Error__UnexpectedRestResponse;

export type Asset__Defect__UpdateInput = {
  id: Scalars['ID'];
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Asset__HasOne = {
  asset: Asset__Result;
};

export type Asset__HasOneMaybe = {
  asset?: Maybe<Asset>;
};

export type Asset__HasVehicleAndOrTrailers = {
  vehicle?: Maybe<Asset__Result>;
  trailers?: Maybe<Array<Asset__Result>>;
};

export type Asset__HasVehiclesMaybe = {
  vehicles?: Maybe<Array<Maybe<Asset__Result>>>;
};

export type Asset__Result = Asset | Error__AccessForbidden | Error__EntityNotFound | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Asset__Type = Node & {
  __typename?: 'Asset__Type';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Before_MayHaveOne = {
  before?: Maybe<Scalars['JSON']>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type ClientApplication = Node & {
  __typename?: 'ClientApplication';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Comment = Node & Lifecycle__HasOne & Media__HasMany & {
  __typename?: 'Comment';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media__Read__Result>>;
};

export type Comment__CreateInput = {
  text?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Media__Type__File__CreateInput>>;
  images?: Maybe<Array<Media__Type__Image__CreateInput>>;
  lifecycle: Lifecycle__CreateInput;
};

export type Comment__Create__Result = Comment | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Comment__Delete__Result = Comment | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Comment__HasMany = {
  comments?: Maybe<Array<Maybe<Comment>>>;
};

export type Comment__Mutations = {
  __typename?: 'Comment__Mutations';
  create?: Maybe<Comment__Create__Result>;
  delete?: Maybe<Comment__Delete__Result>;
  restore?: Maybe<Comment__Restore__Result>;
};


export type Comment__MutationsCreateArgs = {
  input: Comment__CreateInput;
};


export type Comment__MutationsDeleteArgs = {
  id: Scalars['ID'];
};


export type Comment__MutationsRestoreArgs = {
  id: Scalars['ID'];
};

export type Comment__Read__Result = Comment | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Comment__Restore__Result = Comment | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Company = Node & {
  __typename?: 'Company';
  id: Scalars['ID'];
  name: Scalars['String'];
  hoursOfServiceTypeID: Scalars['ID'];
  ouID: Scalars['ID'];
  timezone?: Maybe<Scalars['String']>;
  settings?: Maybe<Company__Settings__Result>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  shifts?: Maybe<Driver__Shift__ByCompanyQueries>;
  vehicleInspectionReports?: Maybe<Driver__VehicleInspectionReport__ByCompanyQueries>;
  vehicleInspectionReportSummary?: Maybe<Driver__VehicleInspectionReport__Summary__ByCompanyQueries>;
};

export type Company__Input = {
  id: Scalars['ID'];
};

export type Company__Result = Company | Error__AccessForbidden | Error__TimeoutError | Error__UnexpectedRestResponse;

export type Company__Settings = {
  __typename?: 'Company__Settings';
  trackSettings: Company__Settings__Track__Result;
  driveSettings: Company__Settings__Drive__Result;
};

export type Company__Settings__Drive = Node & {
  __typename?: 'Company__Settings__Drive';
  id: Scalars['ID'];
  requireImagesForAllDVIRs: Scalars['Boolean'];
  requireNotesForAllDVIRs: Scalars['Boolean'];
  requireDriverToViewAndAcceptCompanyDefectList: Scalars['Boolean'];
  enableFacialRecognitionPairingSuggestions: Scalars['Boolean'];
  missingDVIRReport?: Maybe<Settings__Recurring__Email__Report>;
  notifyOnAllReportedDefects?: Maybe<Settings__Email__Report>;
  notifyOnHardDownDefects?: Maybe<Settings__Email__Report>;
};

export type Company__Settings__Drive__Result = Company__Settings__Drive | Error__DataIntegrity | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__UnclassifiedError;

export type Company__Settings__Result = Company__Settings | Error__AccessForbidden | Error__EntityNotFound | Error__TimeoutError | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Company__Settings__Track = Node & {
  __typename?: 'Company__Settings__Track';
  id: Scalars['ID'];
  createWorkOrdersForDVIRs: Scalars['Boolean'];
};

export type Company__Settings__Track__Result = Company__Settings__Track | Error__AccessForbidden | Error__EntityNotFound | Error__TimeoutError | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Company__Settings__UpdateInput = {
  requireImagesForAllDVIRs: Scalars['Boolean'];
  requireNotesForAllDVIRs: Scalars['Boolean'];
  requireDriverToViewAndAcceptCompanyDefectList: Scalars['Boolean'];
  enableFacialRecognitionPairingSuggestions: Scalars['Boolean'];
};


export type DateTime__HasOne = {
  dateTime: Scalars['DateTime'];
};

export type Driver = Node & Human & {
  __typename?: 'Driver';
  id: Scalars['ID'];
  name: Human__Name;
  vehicleInspectionReports?: Maybe<Driver__VehicleInspectionReport__ByDriverQueries>;
  shifts?: Maybe<Driver__Shift__Queries>;
};

export type Driver__HasOne = {
  driver: Driver__Result;
};

export type Driver__Mutations = {
  __typename?: 'Driver__Mutations';
  vehicleInspectionReport: Driver__VehicleInspectionReport__Mutations;
};

export type Driver__Result = Driver | Error__AccessForbidden | Error__TimeoutError | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Driver__Shift = Asset__HasVehiclesMaybe & {
  __typename?: 'Driver__Shift';
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  hasDriveTime: Scalars['Boolean'];
  hasTrackerDriveTime: Scalars['Boolean'];
  isOngoing: Scalars['Boolean'];
  driveDistance: Scalars['Float'];
  onDutyDuration: Scalars['String'];
  vehicles?: Maybe<Array<Maybe<Asset__Result>>>;
};

export type Driver__Shift__ByCompanyQueries = {
  __typename?: 'Driver__Shift__ByCompanyQueries';
  byDateRange: Driver__Shift__Connection__Result;
};


export type Driver__Shift__ByCompanyQueriesByDateRangeArgs = {
  input: Driver__Shift__DateRangePaginated;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type Driver__Shift__Connection = Pagination__Connection & {
  __typename?: 'Driver__Shift__Connection';
  edges?: Maybe<Array<Driver__Shift__Edge>>;
  pageInfo: Pagination__PageInfo;
  totalCount: Scalars['Int'];
};

export type Driver__Shift__Connection__Result = Driver__Shift__Connection | Error__AccessForbidden | Error__EntityNotFound | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Driver__Shift__DateRange = {
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
  includeShiftResetTime?: Maybe<Scalars['Boolean']>;
};

export type Driver__Shift__DateRangePaginated = {
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
  includeShiftResetTime?: Maybe<Scalars['Boolean']>;
  reporting_location_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  branchIDs?: Maybe<Array<Scalars['String']>>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
  driverIDs?: Maybe<Array<Scalars['String']>>;
};

export type Driver__Shift__Edge = Pagination__Edge & {
  __typename?: 'Driver__Shift__Edge';
  cursor: Scalars['String'];
  node: Driver__Shift__Node;
};

export type Driver__Shift__Node = Node & {
  __typename?: 'Driver__Shift__Node';
  id: Scalars['ID'];
  shifts?: Maybe<Array<Driver__Shift>>;
};

export type Driver__Shift__Queries = {
  __typename?: 'Driver__Shift__Queries';
  byDateRange?: Maybe<Array<Driver__Shift__Result>>;
};


export type Driver__Shift__QueriesByDateRangeArgs = {
  input: Driver__Shift__DateRange;
};

export type Driver__Shift__Result = Driver__Shift | Error__AccessForbidden | Error__EntityNotFound | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Driver__VehicleInspectionReport = Node & Driver__HasOne & Lifecycle__HasOne & Comment__HasMany & Media__HasMany & Asset__HasVehicleAndOrTrailers & Asset__Comments__And__Media__HasMany & Asset__Defect__HasMany & Signature__HasOne & {
  __typename?: 'Driver__VehicleInspectionReport';
  id: Scalars['ID'];
  driver: Driver__Result;
  lifecycle: Lifecycle;
  comments?: Maybe<Array<Maybe<Comment>>>;
  media?: Maybe<Array<Media__Read__Result>>;
  signature: Signature;
  vehicle?: Maybe<Asset__Result>;
  trailers?: Maybe<Array<Asset__Result>>;
  defects?: Maybe<Array<Maybe<Asset__Defect>>>;
  assetCommentsAndMedia?: Maybe<Array<Maybe<Asset__Comments__And__Media__Result>>>;
  type: Driver__VehicleInspectionReport__Type;
  pdf: Scalars['String'];
};

export type Driver__VehicleInspectionReport__Asset__Comments__And__Media__CreateInput = {
  assetID: Scalars['ID'];
  lifecycle: Lifecycle__CreateInput;
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Driver__VehicleInspectionReport__Asset__Defect__CreateInput = {
  assetID: Scalars['ID'];
  assetDefectTypeID: Scalars['ID'];
  severity: Asset__Defect__Severity;
  lifecycle: Lifecycle__CreateInput;
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

/** Use this input when associating existing unresolved defects with a new DVIR. */
export type Driver__VehicleInspectionReport__Asset__Defect__ExistingDefectInput = {
  assetDefectID: Scalars['ID'];
  comments?: Maybe<Array<Comment__CreateInput>>;
  media?: Maybe<Array<Media__Type__Image__CreateInput>>;
};

export type Driver__VehicleInspectionReport__ByAssetQueries = {
  __typename?: 'Driver__VehicleInspectionReport__ByAssetQueries';
  all?: Maybe<Array<Driver__VehicleInspectionReport__Result>>;
};

export type Driver__VehicleInspectionReport__ByCompanyQueries = {
  __typename?: 'Driver__VehicleInspectionReport__ByCompanyQueries';
  bySubmittedDateRange: Driver__VehicleInspectionReport__Connection__Result;
  byID?: Maybe<Driver__VehicleInspectionReport__Result>;
};


export type Driver__VehicleInspectionReport__ByCompanyQueriesBySubmittedDateRangeArgs = {
  input: Driver__VehicleInspectionReport__SubmittedDateRange;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type Driver__VehicleInspectionReport__ByCompanyQueriesByIdArgs = {
  id: Scalars['ID'];
};

export type Driver__VehicleInspectionReport__ByDriverQueries = {
  __typename?: 'Driver__VehicleInspectionReport__ByDriverQueries';
  all?: Maybe<Driver__VehicleInspectionReport__Connection__Result>;
  bySubmittedDateRange?: Maybe<Array<Driver__VehicleInspectionReport__Result>>;
};


export type Driver__VehicleInspectionReport__ByDriverQueriesAllArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type Driver__VehicleInspectionReport__ByDriverQueriesBySubmittedDateRangeArgs = {
  input: Driver__VehicleInspectionReport__SubmittedDateRange;
};

export type Driver__VehicleInspectionReport__Connection = Pagination__Connection & {
  __typename?: 'Driver__VehicleInspectionReport__Connection';
  edges?: Maybe<Array<Driver__VehicleInspectionReport__Edge>>;
  pageInfo: Pagination__PageInfo;
  totalCount: Scalars['Int'];
};

export type Driver__VehicleInspectionReport__Connection__Result = Driver__VehicleInspectionReport__Connection | Error__EntityNotFound | Error__DataIntegrity | Error__InputValidation | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__UnclassifiedError | Error__UnexpectedRestResponse | Error__AccessForbidden;

export type Driver__VehicleInspectionReport__CreateInput = {
  driverID: Scalars['ID'];
  type: Driver__VehicleInspectionReport__Type;
  vehicleAssetID?: Maybe<Scalars['ID']>;
  signatureID: Scalars['ID'];
  trailers?: Maybe<Array<Scalars['ID']>>;
  comments?: Maybe<Array<Comment__CreateInput>>;
  lifecycle: Lifecycle__CreateInput;
  defects?: Maybe<Array<Driver__VehicleInspectionReport__Asset__Defect__CreateInput>>;
  assetCommentsAndMedia?: Maybe<Array<Driver__VehicleInspectionReport__Asset__Comments__And__Media__CreateInput>>;
  /** Unresolved existing defects to associate with the DVIR to be created. */
  existingDefects?: Maybe<Array<Driver__VehicleInspectionReport__Asset__Defect__ExistingDefectInput>>;
};

export type Driver__VehicleInspectionReport__DeleteInput = {
  ids: Array<Scalars['ID']>;
};

export type Driver__VehicleInspectionReport__Driver__Summary = {
  __typename?: 'Driver__VehicleInspectionReport__Driver__Summary';
  driverID: Scalars['Int'];
  minDate: Scalars['DateTime'];
  maxDate: Scalars['DateTime'];
  totalDVIRs: Scalars['Int'];
  noDefectDVIRs: Scalars['Int'];
  resolvedDefects: Scalars['Int'];
  unresolvedDefects: Scalars['Int'];
};

export type Driver__VehicleInspectionReport__Edge = Pagination__Edge & {
  __typename?: 'Driver__VehicleInspectionReport__Edge';
  cursor: Scalars['String'];
  node: Driver__VehicleInspectionReport;
};

export type Driver__VehicleInspectionReport__HasMany = {
  vehicleInspectionReports?: Maybe<Array<Maybe<Driver__VehicleInspectionReport>>>;
};

export type Driver__VehicleInspectionReport__Mutations = {
  __typename?: 'Driver__VehicleInspectionReport__Mutations';
  create?: Maybe<Driver__VehicleInspectionReport__Result>;
  delete?: Maybe<Array<Maybe<Driver__VehicleInspectionReport__Result>>>;
  restore?: Maybe<Array<Maybe<Driver__VehicleInspectionReport__Result>>>;
  defects: Asset__Defect__Mutations;
};


export type Driver__VehicleInspectionReport__MutationsCreateArgs = {
  input: Driver__VehicleInspectionReport__CreateInput;
};


export type Driver__VehicleInspectionReport__MutationsDeleteArgs = {
  ids: Array<Scalars['ID']>;
};


export type Driver__VehicleInspectionReport__MutationsRestoreArgs = {
  ids: Array<Scalars['ID']>;
};

export type Driver__VehicleInspectionReport__Result = Driver__VehicleInspectionReport | Error__EntityNotFound | Error__DataIntegrity | Error__InputValidation | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__UnclassifiedError | Error__UnexpectedRestResponse | Error__AccessForbidden;

export type Driver__VehicleInspectionReport__SubmittedDateRange = {
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
  reporting_location_ids?: Maybe<Array<Scalars['String']>>;
  branchIDs?: Maybe<Array<Scalars['String']>>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
};

export type Driver__VehicleInspectionReport__Summary = {
  __typename?: 'Driver__VehicleInspectionReport__Summary';
  date: Scalars['DateTime'];
  minDate: Scalars['DateTime'];
  maxDate: Scalars['DateTime'];
  totalDVIRs: Scalars['Int'];
  noDefectDVIRs: Scalars['Int'];
  resolvedDefects: Scalars['Int'];
  unresolvedDefects: Scalars['Int'];
  driversSummary?: Maybe<Array<Driver__VehicleInspectionReport__Driver__Summary>>;
};

export type Driver__VehicleInspectionReport__Summary__ByCompanyQueries = {
  __typename?: 'Driver__VehicleInspectionReport__Summary__ByCompanyQueries';
  bySubmittedDateRange?: Maybe<Array<Driver__VehicleInspectionReport__Summary__Result>>;
};


export type Driver__VehicleInspectionReport__Summary__ByCompanyQueriesBySubmittedDateRangeArgs = {
  input: Driver__VehicleInspectionReport__Summary__QueryInput;
};

export type Driver__VehicleInspectionReport__Summary__QueryInput = {
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
  timezone?: Maybe<Scalars['String']>;
  reporting_location_ids?: Maybe<Array<Scalars['String']>>;
  branchIDs?: Maybe<Array<Scalars['String']>>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
  driverIDs?: Maybe<Array<Scalars['String']>>;
};

export type Driver__VehicleInspectionReport__Summary__Result = Driver__VehicleInspectionReport__Summary | Error__EntityNotFound | Error__InputValidation | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine | Error__UnclassifiedError;

export enum Driver__VehicleInspectionReport__Type {
  General = 'GENERAL',
  Incident = 'INCIDENT',
  PreTrip = 'PRE_TRIP',
  PostTrip = 'POST_TRIP'
}

export type Error = {
  message: Scalars['String'];
};

export type Error__AccessForbidden = Error & Error__Entity__HasOne & {
  __typename?: 'Error__AccessForbidden';
  message: Scalars['String'];
  entity: Scalars['String'];
};

export type Error__Action__HasOneMaybe = {
  action?: Maybe<Scalars['String']>;
};

export type Error__Code__HasOneMaybe = {
  code?: Maybe<Scalars['String']>;
};

export type Error__DataIntegrity = Error & Error__Entity__HasOne & Error__Source__HasOneMaybe & Error__Node__HasOneMaybe & {
  __typename?: 'Error__DataIntegrity';
  message: Scalars['String'];
  entity: Scalars['String'];
  source?: Maybe<Error__SourceError>;
  node?: Maybe<Node>;
};

export type Error__DatabaseBadRequest = Error & Error__Source__HasOneMaybe & {
  __typename?: 'Error__DatabaseBadRequest';
  message: Scalars['String'];
  source?: Maybe<Error__SourceError>;
  name?: Maybe<Scalars['String']>;
};

export type Error__DatabaseEngine = Error & Error__Source__HasOneMaybe & {
  __typename?: 'Error__DatabaseEngine';
  message: Scalars['String'];
  source?: Maybe<Error__SourceError>;
  name?: Maybe<Scalars['String']>;
};

export type Error__DatabaseException = Error & Error__Source__HasOneMaybe & Error__Code__HasOneMaybe & {
  __typename?: 'Error__DatabaseException';
  message: Scalars['String'];
  source?: Maybe<Error__SourceError>;
  code?: Maybe<Scalars['String']>;
};

export type Error__DuplicateEntity = Error & Error__Entity__HasOne & Error__Node__HasOne & {
  __typename?: 'Error__DuplicateEntity';
  message: Scalars['String'];
  entity: Scalars['String'];
  node: Node;
};

export type Error__EntityNotFound = Error & Error__Entity__HasOne & {
  __typename?: 'Error__EntityNotFound';
  message: Scalars['String'];
  entity: Scalars['String'];
};

export type Error__Entity__HasOne = {
  entity: Scalars['String'];
};

export type Error__InputValidation = Error & Error__Node__HasOneMaybe & Error__Entity__HasOne & Error__Action__HasOneMaybe & {
  __typename?: 'Error__InputValidation';
  message: Scalars['String'];
  entity: Scalars['String'];
  node?: Maybe<Node>;
  action?: Maybe<Scalars['String']>;
};

export type Error__Node__HasOne = {
  node: Node;
};

export type Error__Node__HasOneMaybe = {
  node?: Maybe<Node>;
};

export type Error__SourceError = Error & {
  __typename?: 'Error__SourceError';
  message: Scalars['String'];
};

export type Error__Source__HasOneMaybe = {
  source?: Maybe<Error__SourceError>;
};

export type Error__TimeoutError = Error & {
  __typename?: 'Error__TimeoutError';
  message: Scalars['String'];
  code: Scalars['String'];
};

export type Error__UnclassifiedError = Error & {
  __typename?: 'Error__UnclassifiedError';
  message: Scalars['String'];
};

export type Error__UnexpectedRestResponse = Error & {
  __typename?: 'Error__UnexpectedRESTResponse';
  message: Scalars['String'];
};

export type History__HasOne = {
  before?: Maybe<Scalars['JSON']>;
};

export type Human = {
  name: Human__Name;
};

export type Human__HasOne = {
  human: Human;
};

export type Human__Name = {
  __typename?: 'Human__Name';
  first?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['String']>;
  display: Scalars['String'];
};


export type Lifecycle = Lifecycle__Submitted & Lifecycle__Created & Lifecycle__Modified & Lifecycle__Restored & Lifecycle__Deleted & {
  __typename?: 'Lifecycle';
  isDeleted: Scalars['Boolean'];
  submitted: Lifecycle__Event;
  created: Lifecycle__Event;
  modified?: Maybe<Array<Maybe<Lifecycle__Event>>>;
  restored?: Maybe<Array<Maybe<Lifecycle__Event>>>;
  deleted?: Maybe<Array<Maybe<Lifecycle__Event>>>;
};

export type Lifecycle__CreateInput = {
  submitted?: Maybe<Lifecycle__Event__CreateInput>;
};

export type Lifecycle__Created = {
  created: Lifecycle__Event;
};

export type Lifecycle__Deleted = {
  deleted?: Maybe<Array<Maybe<Lifecycle__Event>>>;
};

export type Lifecycle__Event = Node & Actor__HasOne & Before_MayHaveOne & {
  __typename?: 'Lifecycle__Event';
  id: Scalars['ID'];
  dateTime: Scalars['DateTime'];
  actor: Actor;
  before?: Maybe<Scalars['JSON']>;
  lifecycle: Lifecycle;
};

export type Lifecycle__Event__CreateInput = {
  actor: Actor__CreateInput;
  date?: Maybe<Scalars['DateTime']>;
};

export type Lifecycle__HasOne = {
  lifecycle: Lifecycle;
};

export type Lifecycle__Modified = {
  modified?: Maybe<Array<Maybe<Lifecycle__Event>>>;
};

export type Lifecycle__Restored = {
  restored?: Maybe<Array<Maybe<Lifecycle__Event>>>;
};

export type Lifecycle__Result = Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Lifecycle__Submitted = {
  submitted: Lifecycle__Event;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['ID'];
  gps?: Maybe<Location__Gps>;
  lifecycle: Lifecycle;
};

export type Location__CreateInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  lifecycle: Lifecycle__CreateInput;
};

export type Location__Create__Result = Location | Error__DataIntegrity | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Location__Delete__Result = Location | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Location__Gps = {
  __typename?: 'Location__GPS';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Location__HasOneMaybe = {
  location?: Maybe<Location>;
};

export type Location__Mutations = {
  __typename?: 'Location__Mutations';
  create?: Maybe<Location__Create__Result>;
  delete?: Maybe<Location__Delete__Result>;
  restore?: Maybe<Location__Restore__Result>;
};


export type Location__MutationsCreateArgs = {
  input: Location__CreateInput;
};


export type Location__MutationsDeleteArgs = {
  id: Scalars['ID'];
};


export type Location__MutationsRestoreArgs = {
  id: Scalars['ID'];
};

export type Location__Read__Result = Location | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Location__Restore__Result = Location | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Media = Node & Lifecycle__HasOne & {
  __typename?: 'Media';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  type: Media__Type;
};

export type Media__Create__Result = Media | Error__DataIntegrity | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Media__Delete__Result = Media | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Media__HasMany = {
  media?: Maybe<Array<Media__Read__Result>>;
};

export type Media__Read__Result = Media | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Media__Restore__Result = Media | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Media__Type = Media__Type__File | Media__Type__Image;

export type Media__Type__File = {
  __typename?: 'Media__Type__File';
  uri: Scalars['URI'];
};

export type Media__Type__File__CreateInput = {
  lifecycle: Lifecycle__CreateInput;
  uri: Scalars['URI'];
};

export type Media__Type__Image = Location__HasOneMaybe & {
  __typename?: 'Media__Type__Image';
  location?: Maybe<Location>;
  title?: Maybe<Scalars['String']>;
  file: Media__Type__File;
};

export type Media__Type__Image__CreateInput = {
  title?: Maybe<Scalars['String']>;
  location?: Maybe<Location__CreateInput>;
  uri: Scalars['URI'];
  lifecycle: Lifecycle__CreateInput;
};

export type Media__Type__Mutations = {
  __typename?: 'Media__Type__Mutations';
  createFile: Media__Create__Result;
  createImage: Media__Create__Result;
  delete?: Maybe<Media__Delete__Result>;
  restore?: Maybe<Media__Restore__Result>;
};


export type Media__Type__MutationsCreateFileArgs = {
  input: Media__Type__File__CreateInput;
};


export type Media__Type__MutationsCreateImageArgs = {
  input: Media__Type__Image__CreateInput;
};


export type Media__Type__MutationsDeleteArgs = {
  id: Scalars['ID'];
};


export type Media__Type__MutationsRestoreArgs = {
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  comments?: Maybe<Comment__Mutations>;
  companySettingsUpdate?: Maybe<Company__Settings__Drive__Result>;
  driver?: Maybe<Driver__Mutations>;
  vehicleInspectionReport: Driver__VehicleInspectionReport__Mutations;
  dvirAssetCommentsAndMediaUpdate?: Maybe<Asset__Comments__And__Media__Result>;
  locations?: Maybe<Location__Mutations>;
  media?: Maybe<Media__Type__Mutations>;
  assetDefectTypes?: Maybe<Asset__Defect__Type__Mutations>;
  signatures?: Maybe<Signature__Mutations>;
};


export type MutationCompanySettingsUpdateArgs = {
  companyID: Scalars['ID'];
  input?: Maybe<Company__Settings__UpdateInput>;
};


export type MutationDvirAssetCommentsAndMediaUpdateArgs = {
  input: Asset__Comments__And__Media__UpdateInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type Pagination__Connection = {
  pageInfo: Pagination__PageInfo;
  totalCount: Scalars['Int'];
};

export type Pagination__Edge = {
  cursor: Scalars['String'];
};

export type Pagination__HasPagination = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

export type Pagination__Input = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

export type Pagination__PageInfo = {
  __typename?: 'Pagination__PageInfo';
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  asset?: Maybe<Asset__Result>;
  assetDefectTypes?: Maybe<Asset__Defect__Type__Queries>;
  assetTypes?: Maybe<Array<Asset__Type>>;
  assetType?: Maybe<Asset__Type>;
  comment?: Maybe<Comment__Read__Result>;
  companies?: Maybe<Company__Result>;
  driver?: Maybe<Driver__Result>;
  lifecycle: Lifecycle__Result;
  lifecycleEvent: Lifecycle__Event;
  lifecycleEvents?: Maybe<Array<Maybe<Lifecycle__Event>>>;
  lifecycleCreatedEvents?: Maybe<Array<Maybe<Lifecycle__Created>>>;
  location?: Maybe<Location__Read__Result>;
  media?: Maybe<Media__Read__Result>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  signature?: Maybe<Signature__Read__Result>;
  workOrder?: Maybe<WorkOrder__Result>;
  versions?: Maybe<Version__Result>;
};


export type QueryAssetArgs = {
  id: Scalars['ID'];
};


export type QueryAssetTypeArgs = {
  id: Scalars['ID'];
};


export type QueryCommentArgs = {
  id: Scalars['ID'];
};


export type QueryCompaniesArgs = {
  id: Scalars['ID'];
};


export type QueryDriverArgs = {
  id: Scalars['ID'];
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryMediaArgs = {
  id: Scalars['ID'];
};


export type QuerySignatureArgs = {
  id: Scalars['ID'];
};


export type QueryWorkOrderArgs = {
  id: Scalars['ID'];
};

export type Settings__Email__Address__List = {
  sendTo?: Maybe<Array<Scalars['String']>>;
};

export type Settings__Email__Report = Settings__Email__Address__List & {
  __typename?: 'Settings__Email__Report';
  sendTo?: Maybe<Array<Scalars['String']>>;
};

export type Settings__Recurring__Email__Report = Settings__Email__Address__List & {
  __typename?: 'Settings__Recurring__Email__Report';
  recurrence: Scalars['String'];
  sendTo?: Maybe<Array<Scalars['String']>>;
};

export type Signature = Node & Lifecycle__HasOne & {
  __typename?: 'Signature';
  id: Scalars['ID'];
  lifecycle: Lifecycle;
  image?: Maybe<Media__Type__Image>;
};

export type Signature__CreateInput = {
  image?: Maybe<Media__Type__Image__CreateInput>;
  lifecycle: Lifecycle__CreateInput;
};

export type Signature__Create__Result = Signature | Error__DataIntegrity | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Signature__Delete__Result = Signature | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Signature__HasOne = {
  signature: Signature;
};

export type Signature__Mutations = {
  __typename?: 'Signature__Mutations';
  create?: Maybe<Signature__Create__Result>;
  delete?: Maybe<Signature__Delete__Result>;
  restore?: Maybe<Signature__Restore__Result>;
};


export type Signature__MutationsCreateArgs = {
  input: Signature__CreateInput;
};


export type Signature__MutationsDeleteArgs = {
  id: Scalars['ID'];
};


export type Signature__MutationsRestoreArgs = {
  id: Scalars['ID'];
};

export type Signature__Read__Result = Signature | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;

export type Signature__Restore__Result = Signature | Error__EntityNotFound | Error__DatabaseException | Error__DatabaseBadRequest | Error__DatabaseEngine;


export type Version = {
  __typename?: 'Version';
  binaryVersion?: Maybe<Scalars['String']>;
  codepushVersion?: Maybe<Scalars['String']>;
  minimumBinaryVersion?: Maybe<Scalars['String']>;
};

export type Version__Result = Versions | Error__AccessForbidden | Error__EntityNotFound | Error__TimeoutError | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type Versions = {
  __typename?: 'Versions';
  android?: Maybe<Version>;
  ios?: Maybe<Version>;
};

export type WorkOrder = Node & Asset__HasOneMaybe & {
  __typename?: 'WorkOrder';
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  asset?: Maybe<Asset>;
};

export type WorkOrder__HasMany = {
  workOrders?: Maybe<Array<Maybe<WorkOrder__Result>>>;
};

export type WorkOrder__Result = WorkOrder | Error__AccessForbidden | Error__EntityNotFound | Error__TimeoutError | Error__UnexpectedRestResponse | Error__UnclassifiedError;

export type AssetFragment = (
  { __typename?: 'Asset' }
  & Pick<Asset, 'id' | 'customName'>
);

type Asset__Result_Asset_Fragment = (
  { __typename?: 'Asset' }
  & AssetFragment
);

type Asset__Result_Error__AccessForbidden_Fragment = (
  { __typename?: 'Error__AccessForbidden' }
  & Error_Error__AccessForbidden_Fragment
);

type Asset__Result_Error__EntityNotFound_Fragment = (
  { __typename?: 'Error__EntityNotFound' }
  & Error_Error__EntityNotFound_Fragment
);

type Asset__Result_Error__UnexpectedRestResponse_Fragment = (
  { __typename?: 'Error__UnexpectedRESTResponse' }
  & Error_Error__UnexpectedRestResponse_Fragment
);

type Asset__Result_Error__UnclassifiedError_Fragment = (
  { __typename?: 'Error__UnclassifiedError' }
  & Error_Error__UnclassifiedError_Fragment
);

export type Asset__ResultFragment = Asset__Result_Asset_Fragment | Asset__Result_Error__AccessForbidden_Fragment | Asset__Result_Error__EntityNotFound_Fragment | Asset__Result_Error__UnexpectedRestResponse_Fragment | Asset__Result_Error__UnclassifiedError_Fragment;

export type CommentFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, 'id' | 'text'>
  & Submitted_Comment_Fragment
  & Media_Comment_Fragment
);

type Comments_Asset__Comments__And__Media_Fragment = (
  { __typename?: 'Asset__Comments__And__Media' }
  & { comments?: Maybe<Array<Maybe<(
    { __typename?: 'Comment' }
    & CommentFragment
  )>>> }
);

type Comments_Asset__Defect_Fragment = (
  { __typename?: 'Asset__Defect' }
  & { comments?: Maybe<Array<Maybe<(
    { __typename?: 'Comment' }
    & CommentFragment
  )>>> }
);

type Comments_Asset__Defect__Resolution_Fragment = (
  { __typename?: 'Asset__Defect__Resolution' }
  & { comments?: Maybe<Array<Maybe<(
    { __typename?: 'Comment' }
    & CommentFragment
  )>>> }
);

type Comments_Driver__VehicleInspectionReport_Fragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { comments?: Maybe<Array<Maybe<(
    { __typename?: 'Comment' }
    & CommentFragment
  )>>> }
);

export type CommentsFragment = Comments_Asset__Comments__And__Media_Fragment | Comments_Asset__Defect_Fragment | Comments_Asset__Defect__Resolution_Fragment | Comments_Driver__VehicleInspectionReport_Fragment;

export type TrackSettingsFragment = (
  { __typename?: 'Company__Settings' }
  & { trackSettings: (
    { __typename?: 'Company__Settings__Track' }
    & Pick<Company__Settings__Track, 'createWorkOrdersForDVIRs'>
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Pick<Error__AccessForbidden, 'message'>
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Pick<Error__EntityNotFound, 'message'>
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & Pick<Error__TimeoutError, 'message'>
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Pick<Error__UnexpectedRestResponse, 'message'>
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Pick<Error__UnclassifiedError, 'message'>
  ) }
);

export type DriveSettingsFragment = (
  { __typename?: 'Company__Settings' }
  & { driveSettings: (
    { __typename?: 'Company__Settings__Drive' }
    & Pick<Company__Settings__Drive, 'requireImagesForAllDVIRs' | 'requireNotesForAllDVIRs' | 'requireDriverToViewAndAcceptCompanyDefectList' | 'enableFacialRecognitionPairingSuggestions'>
  ) | (
    { __typename?: 'Error__DataIntegrity' }
    & Pick<Error__DataIntegrity, 'message'>
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Pick<Error__EntityNotFound, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Pick<Error__DatabaseException, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Pick<Error__DatabaseBadRequest, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Pick<Error__DatabaseEngine, 'message'>
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Pick<Error__UnclassifiedError, 'message'>
  ) }
);

export type SettingsQueryVariables = Exact<{
  companyID: Scalars['ID'];
}>;


export type SettingsQuery = (
  { __typename?: 'Query' }
  & { companies?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { settings?: Maybe<(
      { __typename?: 'Company__Settings' }
      & TrackSettingsFragment
      & DriveSettingsFragment
    ) | (
      { __typename?: 'Error__AccessForbidden' }
      & Error_Error__AccessForbidden_Fragment
    ) | (
      { __typename?: 'Error__EntityNotFound' }
      & Error_Error__EntityNotFound_Fragment
    ) | (
      { __typename?: 'Error__TimeoutError' }
      & Error_Error__TimeoutError_Fragment
    ) | (
      { __typename?: 'Error__UnexpectedRESTResponse' }
      & Error_Error__UnexpectedRestResponse_Fragment
    ) | (
      { __typename?: 'Error__UnclassifiedError' }
      & Error_Error__UnclassifiedError_Fragment
    )> }
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Error_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & Error_Error__TimeoutError_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Error_Error__UnexpectedRestResponse_Fragment
  )> }
);

export type UpdateCompanySettingsMutationVariables = Exact<{
  companyID: Scalars['ID'];
  requireImages: Scalars['Boolean'];
  requireNotes: Scalars['Boolean'];
  requireDefectListReview: Scalars['Boolean'];
}>;


export type UpdateCompanySettingsMutation = (
  { __typename?: 'Mutation' }
  & { companySettingsUpdate?: Maybe<(
    { __typename?: 'Company__Settings__Drive' }
    & Pick<Company__Settings__Drive, 'requireImagesForAllDVIRs' | 'requireNotesForAllDVIRs' | 'requireDriverToViewAndAcceptCompanyDefectList' | 'enableFacialRecognitionPairingSuggestions'>
  ) | (
    { __typename?: 'Error__DataIntegrity' }
    & Pick<Error__DataIntegrity, 'message'>
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Pick<Error__EntityNotFound, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Pick<Error__DatabaseException, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Pick<Error__DatabaseBadRequest, 'message'>
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Pick<Error__DatabaseEngine, 'message'>
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Pick<Error__UnclassifiedError, 'message'>
  )> }
);

export type DviRsQueryVariables = Exact<{
  companyID: Scalars['ID'];
  start: Scalars['DateTime'];
  stop: Scalars['DateTime'];
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  reportingLocationIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  branchIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
}>;


export type DviRsQuery = (
  { __typename?: 'Query' }
  & { companies?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { vehicleInspectionReports?: Maybe<(
      { __typename?: 'Driver__VehicleInspectionReport__ByCompanyQueries' }
      & { bySubmittedDateRange: (
        { __typename?: 'Driver__VehicleInspectionReport__Connection' }
        & Pick<Driver__VehicleInspectionReport__Connection, 'totalCount'>
        & { pageInfo: (
          { __typename?: 'Pagination__PageInfo' }
          & Pick<Pagination__PageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ), edges?: Maybe<Array<(
          { __typename?: 'Driver__VehicleInspectionReport__Edge' }
          & Pick<Driver__VehicleInspectionReport__Edge, 'cursor'>
          & { node: (
            { __typename?: 'Driver__VehicleInspectionReport' }
            & DvirFragment
          ) }
        )>> }
      ) | (
        { __typename?: 'Error__EntityNotFound' }
        & Error_Error__EntityNotFound_Fragment
      ) | (
        { __typename?: 'Error__DataIntegrity' }
        & Error_Error__DataIntegrity_Fragment
      ) | (
        { __typename?: 'Error__InputValidation' }
        & Error_Error__InputValidation_Fragment
      ) | (
        { __typename?: 'Error__DatabaseException' }
        & Error_Error__DatabaseException_Fragment
      ) | (
        { __typename?: 'Error__DatabaseBadRequest' }
        & Error_Error__DatabaseBadRequest_Fragment
      ) | (
        { __typename?: 'Error__DatabaseEngine' }
        & Error_Error__DatabaseEngine_Fragment
      ) | (
        { __typename?: 'Error__UnclassifiedError' }
        & Error_Error__UnclassifiedError_Fragment
      ) | (
        { __typename?: 'Error__UnexpectedRESTResponse' }
        & Error_Error__UnexpectedRestResponse_Fragment
      ) | (
        { __typename?: 'Error__AccessForbidden' }
        & Error_Error__AccessForbidden_Fragment
      ) }
    )> }
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Error_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & Error_Error__TimeoutError_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Error_Error__UnexpectedRestResponse_Fragment
  )> }
);

export type GetDvirForDriverByRangeQueryVariables = Exact<{
  driverID: Scalars['ID'];
  start: Scalars['DateTime'];
  stop: Scalars['DateTime'];
}>;


export type GetDvirForDriverByRangeQuery = (
  { __typename?: 'Query' }
  & { driver?: Maybe<(
    { __typename?: 'Driver' }
    & Pick<Driver, 'id'>
    & { vehicleInspectionReports?: Maybe<(
      { __typename?: 'Driver__VehicleInspectionReport__ByDriverQueries' }
      & { bySubmittedDateRange?: Maybe<Array<(
        { __typename?: 'Driver__VehicleInspectionReport' }
        & DvirFragment
      ) | (
        { __typename?: 'Error__EntityNotFound' }
        & Error_Error__EntityNotFound_Fragment
      ) | (
        { __typename?: 'Error__DataIntegrity' }
        & Error_Error__DataIntegrity_Fragment
      ) | (
        { __typename?: 'Error__InputValidation' }
        & Error_Error__InputValidation_Fragment
      ) | (
        { __typename?: 'Error__DatabaseException' }
        & Error_Error__DatabaseException_Fragment
      ) | (
        { __typename?: 'Error__DatabaseBadRequest' }
        & Error_Error__DatabaseBadRequest_Fragment
      ) | (
        { __typename?: 'Error__DatabaseEngine' }
        & Error_Error__DatabaseEngine_Fragment
      ) | (
        { __typename?: 'Error__UnclassifiedError' }
        & Error_Error__UnclassifiedError_Fragment
      ) | (
        { __typename?: 'Error__UnexpectedRESTResponse' }
        & Error_Error__UnexpectedRestResponse_Fragment
      ) | (
        { __typename?: 'Error__AccessForbidden' }
        & Error_Error__AccessForbidden_Fragment
      )>> }
    )> }
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Error_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & Error_Error__TimeoutError_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Error_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Error_Error__UnclassifiedError_Fragment
  )> }
);

export type DvirSummaryQueryVariables = Exact<{
  companyID: Scalars['ID'];
  start: Scalars['DateTime'];
  stop: Scalars['DateTime'];
  zone: Scalars['String'];
  reporting_location_ids?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  branchIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
  driverIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DvirSummaryQuery = (
  { __typename?: 'Query' }
  & { companies?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { vehicleInspectionReportSummary?: Maybe<(
      { __typename?: 'Driver__VehicleInspectionReport__Summary__ByCompanyQueries' }
      & { bySubmittedDateRange?: Maybe<Array<(
        { __typename?: 'Driver__VehicleInspectionReport__Summary' }
        & Pick<Driver__VehicleInspectionReport__Summary, 'date' | 'minDate' | 'maxDate' | 'totalDVIRs' | 'noDefectDVIRs' | 'unresolvedDefects' | 'resolvedDefects'>
        & { driversSummary?: Maybe<Array<(
          { __typename?: 'Driver__VehicleInspectionReport__Driver__Summary' }
          & Pick<Driver__VehicleInspectionReport__Driver__Summary, 'driverID' | 'minDate' | 'maxDate' | 'totalDVIRs' | 'noDefectDVIRs' | 'resolvedDefects' | 'unresolvedDefects'>
        )>> }
      ) | (
        { __typename?: 'Error__EntityNotFound' }
        & Error_Error__EntityNotFound_Fragment
      ) | (
        { __typename?: 'Error__InputValidation' }
        & Error_Error__InputValidation_Fragment
      ) | (
        { __typename?: 'Error__DatabaseException' }
        & Error_Error__DatabaseException_Fragment
      ) | (
        { __typename?: 'Error__DatabaseBadRequest' }
        & Error_Error__DatabaseBadRequest_Fragment
      ) | (
        { __typename?: 'Error__DatabaseEngine' }
        & Error_Error__DatabaseEngine_Fragment
      ) | (
        { __typename?: 'Error__UnclassifiedError' }
        & Error_Error__UnclassifiedError_Fragment
      )>> }
    )> }
  ) | { __typename?: 'Error__AccessForbidden' } | { __typename?: 'Error__TimeoutError' } | { __typename?: 'Error__UnexpectedRESTResponse' }> }
);

export type DefectFragment = (
  { __typename?: 'Asset__Defect' }
  & Pick<Asset__Defect, 'id' | 'severity'>
  & { type: (
    { __typename?: 'Asset__Defect__Type' }
    & Pick<Asset__Defect__Type, 'id' | 'name'>
  ), asset: (
    { __typename?: 'Asset' }
    & Asset__Result_Asset_Fragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Asset__Result_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Asset__Result_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Asset__Result_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Asset__Result_Error__UnclassifiedError_Fragment
  ), resolution?: Maybe<(
    { __typename?: 'Asset__Defect__Resolution' }
    & ResolutionFragment
  )>, workOrders?: Maybe<Array<Maybe<(
    { __typename?: 'WorkOrder' }
    & WorkOrder__Result_WorkOrder_Fragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & WorkOrder__Result_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & WorkOrder__Result_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & WorkOrder__Result_Error__TimeoutError_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & WorkOrder__Result_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & WorkOrder__Result_Error__UnclassifiedError_Fragment
  )>>> }
  & Submitted_Asset__Defect_Fragment
  & Comments_Asset__Defect_Fragment
  & Media_Asset__Defect_Fragment
);

export type ResolutionFragment = (
  { __typename?: 'Asset__Defect__Resolution' }
  & Pick<Asset__Defect__Resolution, 'id' | 'type'>
  & Submitted_Asset__Defect__Resolution_Fragment
  & Signature_Asset__Defect__Resolution_Fragment
  & Comments_Asset__Defect__Resolution_Fragment
);

export type ResolveDefectMutationVariables = Exact<{
  defectID: Scalars['ID'];
  resolution: Asset__Defect__Resolution__Type;
  signatureID: Scalars['ID'];
  lifecycle: Lifecycle__CreateInput;
}>;


export type ResolveDefectMutation = (
  { __typename?: 'Mutation' }
  & { driver?: Maybe<(
    { __typename?: 'Driver__Mutations' }
    & { vehicleInspectionReport: (
      { __typename?: 'Driver__VehicleInspectionReport__Mutations' }
      & { defects: (
        { __typename?: 'Asset__Defect__Mutations' }
        & { resolve?: Maybe<Array<Maybe<(
          { __typename?: 'Asset__Defect__Resolution' }
          & ResolutionFragment
        ) | (
          { __typename?: 'Error__EntityNotFound' }
          & Error_Error__EntityNotFound_Fragment
        ) | (
          { __typename?: 'Error__DuplicateEntity' }
          & Error_Error__DuplicateEntity_Fragment
        ) | (
          { __typename?: 'Error__InputValidation' }
          & Error_Error__InputValidation_Fragment
        ) | (
          { __typename?: 'Error__UnexpectedRESTResponse' }
          & Error_Error__UnexpectedRestResponse_Fragment
        ) | (
          { __typename?: 'Error__UnclassifiedError' }
          & Error_Error__UnclassifiedError_Fragment
        )>>> }
      ) }
    ) }
  )> }
);

export type ResolvedAssetDefectFragment = (
  { __typename?: 'Asset__Defect' }
  & { resolution?: Maybe<(
    { __typename?: 'Asset__Defect__Resolution' }
    & ResolutionFragment
  )> }
);

export type DvirCreateCommentMutationVariables = Exact<{
  defectID: Scalars['ID'];
  dateTime: Scalars['DateTime'];
  userID: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}>;


export type DvirCreateCommentMutation = (
  { __typename?: 'Mutation' }
  & { vehicleInspectionReport: (
    { __typename?: 'Driver__VehicleInspectionReport__Mutations' }
    & { defects: (
      { __typename?: 'Asset__Defect__Mutations' }
      & { update?: Maybe<Array<Maybe<(
        { __typename?: 'Asset__Defect' }
        & Pick<Asset__Defect, 'id'>
        & Comments_Asset__Defect_Fragment
      ) | { __typename?: 'Error__AccessForbidden' } | { __typename?: 'Error__DataIntegrity' } | { __typename?: 'Error__EntityNotFound' } | { __typename?: 'Error__InputValidation' } | { __typename?: 'Error__TimeoutError' } | { __typename?: 'Error__UnclassifiedError' }>>> }
    ) }
  ) }
);

export type DefectsFragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { defects?: Maybe<Array<Maybe<(
    { __typename?: 'Asset__Defect' }
    & DefectFragment
  )>>> }
);

export type GetDefectTagsQueryVariables = Exact<{
  companyID: Scalars['Int'];
}>;


export type GetDefectTagsQuery = (
  { __typename?: 'Query' }
  & { assetDefectTypes?: Maybe<(
    { __typename?: 'Asset__Defect__Type__Queries' }
    & { all?: Maybe<Array<Maybe<(
      { __typename?: 'Asset__Defect__Type' }
      & Pick<Asset__Defect__Type, 'id' | 'name'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'id'>
      )>, assetType: (
        { __typename?: 'Asset__Type' }
        & Pick<Asset__Type, 'id' | 'name'>
      ) }
    ) | (
      { __typename?: 'Error__EntityNotFound' }
      & Error_Error__EntityNotFound_Fragment
    ) | (
      { __typename?: 'Error__InputValidation' }
      & Error_Error__InputValidation_Fragment
    ) | (
      { __typename?: 'Error__DatabaseException' }
      & Error_Error__DatabaseException_Fragment
    ) | (
      { __typename?: 'Error__DatabaseBadRequest' }
      & Error_Error__DatabaseBadRequest_Fragment
    ) | (
      { __typename?: 'Error__DatabaseEngine' }
      & Error_Error__DatabaseEngine_Fragment
    ) | (
      { __typename?: 'Error__AccessForbidden' }
      & Error_Error__AccessForbidden_Fragment
    ) | (
      { __typename?: 'Error__UnexpectedRESTResponse' }
      & Error_Error__UnexpectedRestResponse_Fragment
    )>>> }
  )> }
);

export type AddTagsMutationVariables = Exact<{
  names: Array<Scalars['String']> | Scalars['String'];
  assetTypeID: Scalars['Int'];
  companyID: Scalars['ID'];
}>;


export type AddTagsMutation = (
  { __typename?: 'Mutation' }
  & { AssetDefectTypeAddMany?: Maybe<(
    { __typename?: 'Asset__Defect__Type__Mutations' }
    & { create: Array<Maybe<(
      { __typename?: 'Asset__Defect__Type' }
      & Pick<Asset__Defect__Type, 'id' | 'name'>
    ) | (
      { __typename?: 'Error__EntityNotFound' }
      & Error_Error__EntityNotFound_Fragment
    ) | (
      { __typename?: 'Error__InputValidation' }
      & Error_Error__InputValidation_Fragment
    ) | (
      { __typename?: 'Error__DatabaseException' }
      & Error_Error__DatabaseException_Fragment
    ) | (
      { __typename?: 'Error__DatabaseBadRequest' }
      & Error_Error__DatabaseBadRequest_Fragment
    ) | (
      { __typename?: 'Error__DatabaseEngine' }
      & Error_Error__DatabaseEngine_Fragment
    ) | (
      { __typename?: 'Error__AccessForbidden' }
      & Error_Error__AccessForbidden_Fragment
    ) | (
      { __typename?: 'Error__UnexpectedRESTResponse' }
      & Error_Error__UnexpectedRestResponse_Fragment
    )>> }
  )> }
);

export type RemoveTagsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveTagsMutation = (
  { __typename?: 'Mutation' }
  & { AssetDefectTypeAddMany?: Maybe<(
    { __typename?: 'Asset__Defect__Type__Mutations' }
    & { delete?: Maybe<Array<Maybe<(
      { __typename?: 'Asset__Defect__Type' }
      & Pick<Asset__Defect__Type, 'id' | 'name'>
    ) | (
      { __typename?: 'Error__EntityNotFound' }
      & Error_Error__EntityNotFound_Fragment
    ) | (
      { __typename?: 'Error__InputValidation' }
      & Error_Error__InputValidation_Fragment
    ) | (
      { __typename?: 'Error__DatabaseException' }
      & Error_Error__DatabaseException_Fragment
    ) | (
      { __typename?: 'Error__DatabaseBadRequest' }
      & Error_Error__DatabaseBadRequest_Fragment
    ) | (
      { __typename?: 'Error__DatabaseEngine' }
      & Error_Error__DatabaseEngine_Fragment
    ) | (
      { __typename?: 'Error__AccessForbidden' }
      & Error_Error__AccessForbidden_Fragment
    ) | (
      { __typename?: 'Error__UnexpectedRESTResponse' }
      & Error_Error__UnexpectedRestResponse_Fragment
    )>>> }
  )> }
);

export type DvirFragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & Pick<Driver__VehicleInspectionReport, 'id' | 'type'>
  & { driver: (
    { __typename?: 'Driver' }
    & DriverFragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Error_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__TimeoutError' }
    & Error_Error__TimeoutError_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Error_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Error_Error__UnclassifiedError_Fragment
  ) }
  & Submitted_Driver__VehicleInspectionReport_Fragment
  & VehicleAndTrailersFragment
  & DefectsFragment
  & Signature_Driver__VehicleInspectionReport_Fragment
  & Media_Driver__VehicleInspectionReport_Fragment
  & Comments_Driver__VehicleInspectionReport_Fragment
  & AssetCommentsAndMediaFragment
);

export type AssetCommentsAndMediaFragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { assetCommentsAndMedia?: Maybe<Array<Maybe<(
    { __typename?: 'Asset__Comments__And__Media' }
    & { asset: (
      { __typename?: 'Asset' }
      & Asset__Result_Asset_Fragment
    ) | (
      { __typename?: 'Error__AccessForbidden' }
      & Asset__Result_Error__AccessForbidden_Fragment
    ) | (
      { __typename?: 'Error__EntityNotFound' }
      & Asset__Result_Error__EntityNotFound_Fragment
    ) | (
      { __typename?: 'Error__UnexpectedRESTResponse' }
      & Asset__Result_Error__UnexpectedRestResponse_Fragment
    ) | (
      { __typename?: 'Error__UnclassifiedError' }
      & Asset__Result_Error__UnclassifiedError_Fragment
    ) }
    & Media_Asset__Comments__And__Media_Fragment
    & Comments_Asset__Comments__And__Media_Fragment
    & Submitted_Asset__Comments__And__Media_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Error_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__DataIntegrity' }
    & Error_Error__DataIntegrity_Fragment
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Error_Error__DatabaseException_Fragment
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Error_Error__DatabaseBadRequest_Fragment
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Error_Error__DatabaseEngine_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Error_Error__UnclassifiedError_Fragment
  )>>> }
);

export type VehicleAndTrailersFragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { vehicle?: Maybe<(
    { __typename?: 'Asset' }
    & Asset__Result_Asset_Fragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Asset__Result_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Asset__Result_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Asset__Result_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Asset__Result_Error__UnclassifiedError_Fragment
  )>, trailers?: Maybe<Array<(
    { __typename?: 'Asset' }
    & Asset__Result_Asset_Fragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Asset__Result_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Asset__Result_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Asset__Result_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Asset__Result_Error__UnclassifiedError_Fragment
  )>> }
);

export type ShiftFragment = (
  { __typename?: 'Driver__Shift' }
  & Pick<Driver__Shift, 'startDate' | 'endDate' | 'isOngoing' | 'hasDriveTime' | 'driveDistance'>
  & { vehicles?: Maybe<Array<Maybe<(
    { __typename?: 'Asset' }
    & AssetFragment
  ) | (
    { __typename?: 'Error__AccessForbidden' }
    & Error_Error__AccessForbidden_Fragment
  ) | (
    { __typename?: 'Error__EntityNotFound' }
    & Error_Error__EntityNotFound_Fragment
  ) | (
    { __typename?: 'Error__UnexpectedRESTResponse' }
    & Error_Error__UnexpectedRestResponse_Fragment
  ) | (
    { __typename?: 'Error__UnclassifiedError' }
    & Error_Error__UnclassifiedError_Fragment
  )>>> }
);

export type DriverShiftsFragment = (
  { __typename?: 'Driver__Shift__Node' }
  & Pick<Driver__Shift__Node, 'id'>
  & { shifts?: Maybe<Array<(
    { __typename?: 'Driver__Shift' }
    & ShiftFragment
  )>> }
);

export type ShiftsQueryVariables = Exact<{
  companyID: Scalars['ID'];
  start: Scalars['DateTime'];
  stop: Scalars['DateTime'];
  reporting_location_ids?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  branchIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  includeNoBranch?: Maybe<Scalars['Boolean']>;
  driverIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ShiftsQuery = (
  { __typename?: 'Query' }
  & { companies?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { shifts?: Maybe<(
      { __typename?: 'Driver__Shift__ByCompanyQueries' }
      & { byDateRange: (
        { __typename?: 'Driver__Shift__Connection' }
        & Pick<Driver__Shift__Connection, 'totalCount'>
        & { pageInfo: (
          { __typename?: 'Pagination__PageInfo' }
          & Pick<Pagination__PageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ), edges?: Maybe<Array<(
          { __typename?: 'Driver__Shift__Edge' }
          & Pick<Driver__Shift__Edge, 'cursor'>
          & { node: (
            { __typename?: 'Driver__Shift__Node' }
            & DriverShiftsFragment
          ) }
        )>> }
      ) | (
        { __typename?: 'Error__AccessForbidden' }
        & Error_Error__AccessForbidden_Fragment
      ) | (
        { __typename?: 'Error__EntityNotFound' }
        & Error_Error__EntityNotFound_Fragment
      ) | (
        { __typename?: 'Error__UnexpectedRESTResponse' }
        & Error_Error__UnexpectedRestResponse_Fragment
      ) | (
        { __typename?: 'Error__UnclassifiedError' }
        & Error_Error__UnclassifiedError_Fragment
      ) }
    )> }
  ) | { __typename?: 'Error__AccessForbidden' } | { __typename?: 'Error__TimeoutError' } | { __typename?: 'Error__UnexpectedRESTResponse' }> }
);

export type DriverFragment = (
  { __typename?: 'Driver' }
  & Pick<Driver, 'id'>
  & { name: (
    { __typename?: 'Human__Name' }
    & NameFragment
  ) }
);

type Error_Error__AccessForbidden_Fragment = (
  { __typename?: 'Error__AccessForbidden' }
  & Pick<Error__AccessForbidden, 'message'>
);

type Error_Error__DataIntegrity_Fragment = (
  { __typename?: 'Error__DataIntegrity' }
  & Pick<Error__DataIntegrity, 'message'>
);

type Error_Error__DatabaseBadRequest_Fragment = (
  { __typename?: 'Error__DatabaseBadRequest' }
  & Pick<Error__DatabaseBadRequest, 'message'>
);

type Error_Error__DatabaseEngine_Fragment = (
  { __typename?: 'Error__DatabaseEngine' }
  & Pick<Error__DatabaseEngine, 'message'>
);

type Error_Error__DatabaseException_Fragment = (
  { __typename?: 'Error__DatabaseException' }
  & Pick<Error__DatabaseException, 'message'>
);

type Error_Error__DuplicateEntity_Fragment = (
  { __typename?: 'Error__DuplicateEntity' }
  & Pick<Error__DuplicateEntity, 'message'>
);

type Error_Error__EntityNotFound_Fragment = (
  { __typename?: 'Error__EntityNotFound' }
  & Pick<Error__EntityNotFound, 'message'>
);

type Error_Error__InputValidation_Fragment = (
  { __typename?: 'Error__InputValidation' }
  & Pick<Error__InputValidation, 'message'>
);

type Error_Error__SourceError_Fragment = (
  { __typename?: 'Error__SourceError' }
  & Pick<Error__SourceError, 'message'>
);

type Error_Error__TimeoutError_Fragment = (
  { __typename?: 'Error__TimeoutError' }
  & Pick<Error__TimeoutError, 'message'>
);

type Error_Error__UnclassifiedError_Fragment = (
  { __typename?: 'Error__UnclassifiedError' }
  & Pick<Error__UnclassifiedError, 'message'>
);

type Error_Error__UnexpectedRestResponse_Fragment = (
  { __typename?: 'Error__UnexpectedRESTResponse' }
  & Pick<Error__UnexpectedRestResponse, 'message'>
);

export type ErrorFragment = Error_Error__AccessForbidden_Fragment | Error_Error__DataIntegrity_Fragment | Error_Error__DatabaseBadRequest_Fragment | Error_Error__DatabaseEngine_Fragment | Error_Error__DatabaseException_Fragment | Error_Error__DuplicateEntity_Fragment | Error_Error__EntityNotFound_Fragment | Error_Error__InputValidation_Fragment | Error_Error__SourceError_Fragment | Error_Error__TimeoutError_Fragment | Error_Error__UnclassifiedError_Fragment | Error_Error__UnexpectedRestResponse_Fragment;

export type NameFragment = (
  { __typename?: 'Human__Name' }
  & Pick<Human__Name, 'first' | 'last' | 'display'>
);

type Submitted_Asset__Comments__And__Media_Fragment = (
  { __typename?: 'Asset__Comments__And__Media' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Asset__Defect_Fragment = (
  { __typename?: 'Asset__Defect' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Asset__Defect__Resolution_Fragment = (
  { __typename?: 'Asset__Defect__Resolution' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Asset__Defect__Type_Fragment = (
  { __typename?: 'Asset__Defect__Type' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Comment_Fragment = (
  { __typename?: 'Comment' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Driver__VehicleInspectionReport_Fragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Media_Fragment = (
  { __typename?: 'Media' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

type Submitted_Signature_Fragment = (
  { __typename?: 'Signature' }
  & { lifecycle: (
    { __typename?: 'Lifecycle' }
    & { submitted: (
      { __typename?: 'Lifecycle__Event' }
      & Pick<Lifecycle__Event, 'dateTime'>
      & { actor: (
        { __typename?: 'Actor__Human' }
        & Pick<Actor__Human, 'name' | 'userID'>
      ) | { __typename?: 'Actor__System' } | { __typename?: 'Actor__Unknown' } }
    ) }
  ) }
);

export type SubmittedFragment = Submitted_Asset__Comments__And__Media_Fragment | Submitted_Asset__Defect_Fragment | Submitted_Asset__Defect__Resolution_Fragment | Submitted_Asset__Defect__Type_Fragment | Submitted_Comment_Fragment | Submitted_Driver__VehicleInspectionReport_Fragment | Submitted_Media_Fragment | Submitted_Signature_Fragment;

export type LocationFragment = (
  { __typename?: 'Media__Type__Image' }
  & { location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
    & { gps?: Maybe<(
      { __typename?: 'Location__GPS' }
      & Pick<Location__Gps, 'latitude' | 'longitude'>
    )> }
  )> }
);

export type Media__RawFragment = (
  { __typename?: 'Media' }
  & Pick<Media, 'id'>
  & { type: { __typename?: 'Media__Type__File' } | (
    { __typename?: 'Media__Type__Image' }
    & ImageFragment
  ) }
);

type Media_Asset__Comments__And__Media_Fragment = (
  { __typename?: 'Asset__Comments__And__Media' }
  & { media?: Maybe<Array<(
    { __typename?: 'Media' }
    & Media__RawFragment
  )>> }
);

type Media_Asset__Defect_Fragment = (
  { __typename?: 'Asset__Defect' }
  & { media?: Maybe<Array<(
    { __typename?: 'Media' }
    & Media__RawFragment
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Error_Error__DatabaseException_Fragment
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Error_Error__DatabaseBadRequest_Fragment
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Error_Error__DatabaseEngine_Fragment
  )>> }
);

type Media_Comment_Fragment = (
  { __typename?: 'Comment' }
  & { media?: Maybe<Array<(
    { __typename?: 'Media' }
    & Media__RawFragment
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Error_Error__DatabaseException_Fragment
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Error_Error__DatabaseBadRequest_Fragment
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Error_Error__DatabaseEngine_Fragment
  )>> }
);

type Media_Driver__VehicleInspectionReport_Fragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { media?: Maybe<Array<(
    { __typename?: 'Media' }
    & Media__RawFragment
  ) | (
    { __typename?: 'Error__DatabaseException' }
    & Error_Error__DatabaseException_Fragment
  ) | (
    { __typename?: 'Error__DatabaseBadRequest' }
    & Error_Error__DatabaseBadRequest_Fragment
  ) | (
    { __typename?: 'Error__DatabaseEngine' }
    & Error_Error__DatabaseEngine_Fragment
  )>> }
);

export type MediaFragment = Media_Asset__Comments__And__Media_Fragment | Media_Asset__Defect_Fragment | Media_Comment_Fragment | Media_Driver__VehicleInspectionReport_Fragment;

export type ImageFragment = (
  { __typename?: 'Media__Type__Image' }
  & { file: (
    { __typename?: 'Media__Type__File' }
    & Pick<Media__Type__File, 'uri'>
  ) }
);

type Signature_Asset__Defect__Resolution_Fragment = (
  { __typename?: 'Asset__Defect__Resolution' }
  & { signature: (
    { __typename?: 'Signature' }
    & Pick<Signature, 'id'>
    & { image?: Maybe<(
      { __typename?: 'Media__Type__Image' }
      & ImageFragment
    )> }
    & Submitted_Signature_Fragment
  ) }
);

type Signature_Driver__VehicleInspectionReport_Fragment = (
  { __typename?: 'Driver__VehicleInspectionReport' }
  & { signature: (
    { __typename?: 'Signature' }
    & Pick<Signature, 'id'>
    & { image?: Maybe<(
      { __typename?: 'Media__Type__Image' }
      & ImageFragment
    )> }
    & Submitted_Signature_Fragment
  ) }
);

export type SignatureFragment = Signature_Asset__Defect__Resolution_Fragment | Signature_Driver__VehicleInspectionReport_Fragment;

export type CreateSignatureMutationVariables = Exact<{
  image?: Maybe<Media__Type__Image__CreateInput>;
  lifecycle: Lifecycle__CreateInput;
}>;


export type CreateSignatureMutation = (
  { __typename?: 'Mutation' }
  & { signatures?: Maybe<(
    { __typename?: 'Signature__Mutations' }
    & { create?: Maybe<(
      { __typename?: 'Signature' }
      & Pick<Signature, 'id'>
      & { image?: Maybe<(
        { __typename?: 'Media__Type__Image' }
        & { file: (
          { __typename?: 'Media__Type__File' }
          & Pick<Media__Type__File, 'uri'>
        ) }
      )> }
      & Submitted_Signature_Fragment
    ) | (
      { __typename?: 'Error__DataIntegrity' }
      & Error_Error__DataIntegrity_Fragment
    ) | (
      { __typename?: 'Error__DatabaseException' }
      & Error_Error__DatabaseException_Fragment
    ) | (
      { __typename?: 'Error__DatabaseBadRequest' }
      & Error_Error__DatabaseBadRequest_Fragment
    ) | (
      { __typename?: 'Error__DatabaseEngine' }
      & Error_Error__DatabaseEngine_Fragment
    )> }
  )> }
);

export type WorkOrderFragment = (
  { __typename?: 'WorkOrder' }
  & Pick<WorkOrder, 'id' | 'description'>
);

type WorkOrder__Result_WorkOrder_Fragment = (
  { __typename?: 'WorkOrder' }
  & WorkOrderFragment
);

type WorkOrder__Result_Error__AccessForbidden_Fragment = (
  { __typename?: 'Error__AccessForbidden' }
  & Error_Error__AccessForbidden_Fragment
);

type WorkOrder__Result_Error__EntityNotFound_Fragment = (
  { __typename?: 'Error__EntityNotFound' }
  & Error_Error__EntityNotFound_Fragment
);

type WorkOrder__Result_Error__TimeoutError_Fragment = (
  { __typename?: 'Error__TimeoutError' }
  & Error_Error__TimeoutError_Fragment
);

type WorkOrder__Result_Error__UnexpectedRestResponse_Fragment = (
  { __typename?: 'Error__UnexpectedRESTResponse' }
  & Error_Error__UnexpectedRestResponse_Fragment
);

type WorkOrder__Result_Error__UnclassifiedError_Fragment = (
  { __typename?: 'Error__UnclassifiedError' }
  & Error_Error__UnclassifiedError_Fragment
);

export type WorkOrder__ResultFragment = WorkOrder__Result_WorkOrder_Fragment | WorkOrder__Result_Error__AccessForbidden_Fragment | WorkOrder__Result_Error__EntityNotFound_Fragment | WorkOrder__Result_Error__TimeoutError_Fragment | WorkOrder__Result_Error__UnexpectedRestResponse_Fragment | WorkOrder__Result_Error__UnclassifiedError_Fragment;

export type WorkOrdersFragment = (
  { __typename?: 'Asset__Defect' }
  & { workOrders?: Maybe<Array<Maybe<(
    { __typename?: 'WorkOrder' }
    & Pick<WorkOrder, 'id' | 'description'>
  ) | { __typename?: 'Error__AccessForbidden' } | { __typename?: 'Error__EntityNotFound' } | { __typename?: 'Error__TimeoutError' } | { __typename?: 'Error__UnexpectedRESTResponse' } | { __typename?: 'Error__UnclassifiedError' }>>> }
);
